<template>
  <div class="404">
    <h1>404</h1>
    <h2>Page non trouvée</h2>
  </div>
</template>

<script>
  export default {
    name: 'ErrorNotFound',
    created: function() {

      // Redirect using plain old javascript
      if(window.location.pathname !== '/404')
        window.location.href = "/404";
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  div{ padding-top: 50px; }
  h1, h2{ text-align: center; }
  h1{ color: $color1; font-family: 'ClanFFBlack'; font-size: 100px; font-weight: normal; display: block;

  }
  h2{  color: $color1; font-family: 'ClanFFBlack'; font-size: 40px; color: $grisclair; }
</style>



// WEBPACK FOOTER //
// src/components/Global/ErrorNotFound.vue